! (function ($) {

	'use strict';

	var VideoModal = function () {
		this.init();
	};

	VideoModal.prototype = {

		constructor: VideoModal,

		init: function () {
			this.modal = $('#videoModal');

			this.registerListeners();
		},

		registerListeners: function () {
			var that = this;

			$('[data-toggle="video-modal"]').filter(function(){
				return that.isYouTubeURL($(this).attr('href'));
			}).each(function () {
				$(this).attr({
					'data-toggle': 'modal',
					'data-target': '#videoModal',
					'data-remote': 'false',
					'data-href' : $(this).attr('href')
				})
			});

			$('body').on('youTubeAPIReady', function () {
				that.modal
					.on('show.bs.modal', function () {
						that.initPlayer();
					})
					.on('show.bs.modal', function () {
						that.play();
					})
					.on('hide.bs.modal', function () {
						that.stop();
					});
			});

			return this;
		},

		initPlayer: function () {
			this.modal.find('#videoModalIframeContainer').append('<div id="videoModalIframe" class="video-modal__iframe"/>');

			this.player = new YT.Player('videoModalIframe', {
				width: '100%',
				height: '100%',
				videoId: this.getYouTubeVideoID(this.modal.data('bs.modal').options.href),
				playerVars: {
					rel: 0,
					modestbranding: 1,
					autohide: 1,
					showinfo: 0,
					autoplay: 1
				}
			});
		},

		play: function () {
			if (typeof this.player.playVideo != 'undefined') {
				this.player.playVideo();
			}

			return this;
		},

		stop: function () {
			this.player = null;

			this.modal.find('#videoModalIframe').remove();

			return this;
		},

		isYouTubeURL: function (url) {
			return !!this.getYouTubeVideoID(url);
		},

		/**
		 * JavaScript function to match (and return) the video Id
		 * of any valid Youtube Url, given as input string.
		 * @author: Stephan Schmitz <eyecatchup@gmail.com>
		 * @url: http://stackoverflow.com/a/10315969/624466
		 */
		getYouTubeVideoID: function (url) {
			var p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
			return (url.match(p)) ? RegExp.$1 : false;
		}
	};

	$(document).ready(function () {
		new VideoModal();
	});

})(window.jQuery);
